import background from './background.mp4'
import logo from './logo-no-bg.png'
import './index.css'

function App() {
	return (
	<div className="App" id="outerDiv" >
		<video playsinline autoPlay loop muted style={{width: '100vw', height: '100vh', 
		position: 'absolute', outline: 'none',
			objectFit: 'cover'}}>
			<source src={background} type="video/mp4" />
		</video>
		<div id="contentDiv" >
			<div id="header" >
				<img src={logo} style={{width: '150px', marginLeft: 'auto', marginRight: 'auto'}} />
				<div style={{background: 'white', marginLeft: 'auto', width: '80%', borderRadius: '10px',
				display: 'flex', marginLeft: '15px'
				}} >
					<h2 id="header-text" >Aviso importante!</h2>
				</div>
			</div>
			<div id="content">
				<p className="texto">
				A Fundação Agrisus, com o intuito de melhor atender a comunidade acadêmica e empresarial, e visando a 
				readequação de seus processos e reestruturação de sua governança, informa que temporariamente estará 
				suspendendo a funcionalidade de seu site, 
				preservando todo o conteúdo de informações disponíveis em consonância com a nova Lei Geral de Proteção de 
				Dados (Lei 13.709/2018) .
				</p>
				<p className="texto">
				Para qualquer assunto relacionado a instituição, pedimos a gentileza de entrar em contato diretamente 
				com nossa Coordenação Executiva através do telefone (19) 3432-6556 ou e-mail: agrisus@fealq.com.br.
				</p>
				<p className="texto" >
				Certos de podermos contar com a compreensão de todos.
				</p>
				<p className="texto" >
				Atenciosamente,
				</p>
				<p className="texto" >
				Diretoria Executiva
				</p>

			</div>
		</div>
	</div>
	);
}

export default App;